module.exports = __webpack_public_path__ + "app/kiss-order/detail/order-detail-tabs-1DhBc_cP.html";